import { useEffect } from 'react';

import { NativeStackNavigationOptions } from '@react-navigation/native-stack';
import { Stack } from 'expo-router';
import { enableFreeze } from 'react-native-screens';

import { useGetCartGestureEnabledExperiment } from 'experiments/use-disable-cart-back-gesture';
import {
  ReactNativeScreensFreezeExperimentVariants,
  useReactNativeScreensFreezeExperiment,
} from 'experiments/use-react-native-screens-freeze-experiment';
import { primitive } from 'styles/constants';
import { isIos } from 'utils/environment';

import { App } from '../App';

export const unstable_settings = {
  initialRouteName: '(tabs)',
};

export default function RootLayout() {
  return (
    <App>
      <RootStack />
    </App>
  );
}

const RootStack = () => {
  const gestureEnabled = useGetCartGestureEnabledExperiment(true);

  const { logExposureWhen, freezeVariantValue } = useReactNativeScreensFreezeExperiment();

  useEffect(() => {
    logExposureWhen(ReactNativeScreensFreezeExperimentVariants.Enabled);
    logExposureWhen(ReactNativeScreensFreezeExperimentVariants.Disabled);
    if (
      freezeVariantValue === ReactNativeScreensFreezeExperimentVariants.Enabled ||
      freezeVariantValue === ReactNativeScreensFreezeExperimentVariants.EnabledNoTabBlur
    ) {
      enableFreeze(true);
    } else {
      enableFreeze(false);
    }
  }, [logExposureWhen, freezeVariantValue]);

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: primitive.$mayoEggWhite },
      }}
    >
      <Stack.Screen name="(tabs)" />
      {/* this is like this and here not in (tabs) or (modals) so we can get the full screen no tabs look */}
      <Stack.Screen name="menu/section/[id]" options={{ presentation: 'card' }} />
      <Stack.Screen
        name="(cart)"
        options={{
          gestureEnabled,
        }}
      />
      <Stack.Screen
        name="(modals)"
        options={{
          // provides similar looking modal styles in conjunction with CardModal across OS types
          ...(isIos
            ? {
                presentation: 'modal',
              }
            : {
                presentation: 'transparentModal',
                animation: 'slide_from_bottom',
                contentStyle: { backgroundColor: 'transparent' },
              }),
        }}
      />
      <Stack.Screen
        name="(drawer)"
        options={{
          headerShown: false,
          animation: 'none',
          presentation: 'containedTransparentModal',
          contentStyle: { backgroundColor: 'transparent' },
        }}
      />

      <Stack.Screen name="campaigns/[campaignSlug]" options={getModalOptions()} />
      <Stack.Screen name="autoselect" options={{ presentation: 'modal' }} />

      {/**
       * Handles static pages, redirects, and true 404.
       *
       * NOTE: The none animation and transparent background are used
       * to prevent any visual effect during redirects (only visible
       * in release builds, not in debug!)
       *
       * NOTE: in the future we may be able to make this a "modal" presentation
       * when redirects are no longer used but right now it looks bad with a redirect
       */}
      <Stack.Screen name="+not-found" options={getModalOptions()} />
      <Stack.Screen name="notification-inbox" />
      <Stack.Screen name="signout" options={getModalOptions()} />
      <Stack.Screen
        name="noop"
        options={{
          presentation: 'containedTransparentModal',
          contentStyle: { backgroundColor: 'transparent' },
        }}
      />
      <Stack.Screen name="walmart-redirect" options={getModalOptions()} />
      <Stack.Screen name="walmartLocation" options={getModalOptions()} />
      <Stack.Screen name="walmartplus" options={getModalOptions()} />
    </Stack>
  );
};

const getModalOptions = (): NativeStackNavigationOptions => ({
  presentation: 'containedTransparentModal',
  animation: 'none',
});
